import { createContext } from "react";

export const UserStateContext = createContext(null);